import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "sidebarText"
}
const _hoisted_4 = {
  key: 0,
  class: "sidebarText"
}
const _hoisted_5 = {
  key: 0,
  class: "sidebarText"
}
const _hoisted_6 = {
  key: 0,
  class: "sidebarText"
}
const _hoisted_7 = {
  key: 0,
  class: "sidebarText"
}
const _hoisted_8 = {
  key: 0,
  class: "sidebarText"
}
const _hoisted_9 = {
  key: 0,
  class: "sidebarText"
}
const _hoisted_10 = {
  key: 0,
  class: "sidebarText"
}
const _hoisted_11 = {
  key: 0,
  class: "sidebarText"
}
const _hoisted_12 = { id: "personalSidebar" }
const _hoisted_13 = { class: "sidebarIcon" }
const _hoisted_14 = {
  key: 0,
  class: "notificationCount"
}
const _hoisted_15 = {
  key: 0,
  href: "#",
  class: "sidebarText"
}
const _hoisted_16 = {
  key: 0,
  href: "#",
  class: "sidebarText"
}
const _hoisted_17 = { class: "myAccount" }
const _hoisted_18 = {
  key: 0,
  href: "#",
  class: "sidebarText ml-3"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }

import Avatar from "@/components/Avatar";
import {useGlobalStore} from '@/stores/GlobalStore'
import {computed, ref} from "vue";
import {useRoute} from "vue-router";
import {DisdiStateType} from "@/utilities/enums/Enums";


export default /*@__PURE__*/_defineComponent({
  __name: 'Sidebar',
  setup(__props) {

let openSidebar = ref(true);
const globalStore = useGlobalStore();

const toggleSidebar = () => {
	openSidebar.value = !openSidebar.value
}

const disdiSettingsEnabled = computed<boolean>(()=> globalStore.settings.disdiSettings?.disdi !== DisdiStateType.NoDISDI);
const activitiesFeatureEnabled = computed<boolean>(()=> globalStore.settings.activitySettings?.activitesEnabled === true);

const subIsActive = (input:any) => {
	const paths = Array.isArray(input) ? input : [input];
	const route = useRoute();
	return paths.some(path => {
		return route.path.indexOf(path) === 0 // current path starts with this path string
	})
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock("div", {
    id: "sidebar",
    class: _normalizeClass(["", { openSidebar: _unref(openSidebar) }])
  }, [
    _createElementVNode("div", {
      id: "toggleSidebar",
      onClick: toggleSidebar
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(_unref(openSidebar) ? 'icon-pfeil-links' : 'icon-pfeil-rechts')
      }, null, 2)
    ]),
    _createElementVNode("ul", null, [
      _withDirectives((_openBlock(), _createElementBlock("li", {
        class: _normalizeClass({'active': subIsActive('/registrationReports')})
      }, [
        _createVNode(_component_router_link, {
          class: "flex",
          to: "/registrationReports"
        }, {
          default: _withCtx(() => [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "sidebarIcon" }, [
              _createElementVNode("span", { class: "icon-anmeldereports" })
            ], -1)),
            (_unref(openSidebar))
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.$t("sidebar.RegistrationReports")), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1,
          __: [0]
        })
      ], 2)), [
        [_directive_permission, 'RegistrationReport.Navigation.Show']
      ]),
      _withDirectives((_openBlock(), _createElementBlock("li", {
        class: _normalizeClass({'active': subIsActive('/locationRegistration')})
      }, [
        _createVNode(_component_router_link, {
          class: "flex",
          to: "/locationRegistration"
        }, {
          default: _withCtx(() => [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "sidebarIcon" }, [
              _createElementVNode("span", { class: "icon-standortreports" })
            ], -1)),
            (_unref(openSidebar))
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t("sidebar.LocationRegistration")), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1,
          __: [1]
        })
      ], 2)), [
        [_directive_permission, 'LocationReport.Navigation.Show']
      ]),
      _withDirectives((_openBlock(), _createElementBlock("li", {
        class: _normalizeClass({'active': subIsActive('/users')})
      }, [
        _createVNode(_component_router_link, {
          class: "flex",
          to: "/users"
        }, {
          default: _withCtx(() => [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "sidebarIcon" }, [
              _createElementVNode("span", { class: "icon-benutzer" })
            ], -1)),
            (_unref(openSidebar))
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t("sidebar.User")), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1,
          __: [2]
        })
      ], 2)), [
        [_directive_permission, 'UserAdministrator.User.Navigation.Show']
      ]),
      _withDirectives((_openBlock(), _createElementBlock("li", {
        class: _normalizeClass({'active': subIsActive('/providermanagement')})
      }, [
        _createVNode(_component_router_link, {
          class: "flex",
          to: "/providermanagement"
        }, {
          default: _withCtx(() => [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "sidebarIcon" }, [
              _createElementVNode("span", { class: "icon-dienstleisterverwaltung" })
            ], -1)),
            (_unref(openSidebar))
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t("sidebar.ProviderManagement")), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1,
          __: [3]
        })
      ], 2)), [
        [_directive_permission, 'ProviderManagementPolicy.CompanyWorker.Navigation.Show']
      ]),
      _withDirectives((_openBlock(), _createElementBlock("li", {
        class: _normalizeClass({'active': subIsActive('/locationManagement')})
      }, [
        _createVNode(_component_router_link, {
          class: "flex",
          to: "/locationManagement"
        }, {
          default: _withCtx(() => [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "sidebarIcon" }, [
              _createElementVNode("span", { class: "icon-standortverwaltung" })
            ], -1)),
            (_unref(openSidebar))
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t("sidebar.LocationManagement")), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1,
          __: [4]
        })
      ], 2)), [
        [_directive_permission, 'LocationManagement.Navigation.Show']
      ]),
      _withDirectives((_openBlock(), _createElementBlock("li", {
        class: _normalizeClass({'active': subIsActive('/controlCenter')})
      }, [
        _createVNode(_component_router_link, {
          class: "flex",
          to: "/controlCenter"
        }, {
          default: _withCtx(() => [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "sidebarIcon" }, [
              _createElementVNode("span", { class: "icon-netzleitstellen" })
            ], -1)),
            (_unref(openSidebar))
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t("sidebar.ControlCenter")), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1,
          __: [5]
        })
      ], 2)), [
        [_directive_permission, 'ControlCenter.Navigation.Show']
      ]),
      _withDirectives((_openBlock(), _createElementBlock("li", {
        class: _normalizeClass({'active': subIsActive('/group2')})
      }, [
        _createVNode(_component_router_link, {
          class: "flex",
          to: "/group2"
        }, {
          default: _withCtx(() => [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "sidebarIcon" }, [
              _createElementVNode("span", { class: "icon-typ" })
            ], -1)),
            (_unref(openSidebar))
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t("sidebar.Group2")), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1,
          __: [6]
        })
      ], 2)), [
        [_directive_permission, 'Region.Navigation.Show']
      ]),
      _withDirectives((_openBlock(), _createElementBlock("li", {
        class: _normalizeClass({'active': subIsActive('/group1')})
      }, [
        _createVNode(_component_router_link, {
          class: "flex",
          to: "/group1"
        }, {
          default: _withCtx(() => [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "sidebarIcon" }, [
              _createElementVNode("span", { class: "icon-region" })
            ], -1)),
            (_unref(openSidebar))
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t("sidebar.Group1")), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1,
          __: [7]
        })
      ], 2)), [
        [_directive_permission, 'Region.Navigation.Show']
      ]),
      _withDirectives((_openBlock(), _createElementBlock("li", {
        class: _normalizeClass({'active': subIsActive('/safetyInstructions')})
      }, [
        _createVNode(_component_router_link, {
          class: "flex",
          to: "/safetyInstructions"
        }, {
          default: _withCtx(() => [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "sidebarIcon" }, [
              _createElementVNode("span", { class: "icon-sicherheitshinweise" })
            ], -1)),
            (_unref(openSidebar))
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t("sidebar.SafetyInstructions")), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1,
          __: [8]
        })
      ], 2)), [
        [_directive_permission, 'SafetyInstruction.Navigation.Show']
      ]),
      (activitiesFeatureEnabled.value)
        ? _withDirectives((_openBlock(), _createElementBlock("li", {
            key: 0,
            class: _normalizeClass({'active': subIsActive('/activity')})
          }, [
            _createVNode(_component_router_link, {
              class: "flex",
              to: "/activity"
            }, {
              default: _withCtx(() => [
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "sidebarIcon" }, [
                  _createElementVNode("span", { class: "icon-ttigkeitsgruppen" })
                ], -1)),
                (_unref(openSidebar))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t("sidebar.Activities")), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1,
              __: [9]
            })
          ], 2)), [
            [_directive_permission, 'ActivitySets.Show']
          ])
        : _createCommentVNode("", true),
      (disdiSettingsEnabled.value)
        ? _withDirectives((_openBlock(), _createElementBlock("li", {
            key: 1,
            class: _normalizeClass({'active': subIsActive('/category')})
          }, [
            _createVNode(_component_router_link, {
              class: "flex",
              to: "/category"
            }, {
              default: _withCtx(() => [
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "sidebarIcon" }, [
                  _createElementVNode("span", { class: "icon-kategorien" })
                ], -1)),
                (_unref(openSidebar))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$t("sidebar.CategoryManagement")), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1,
              __: [10]
            })
          ], 2)), [
            [_directive_permission, 'Category.Read']
          ])
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("ul", _hoisted_12, [
      _withDirectives((_openBlock(), _createElementBlock("li", {
        class: _normalizeClass({'active': subIsActive('/notifications')})
      }, [
        _createVNode(_component_router_link, {
          class: "flex",
          to: "/notifications"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_13, [
              _cache[11] || (_cache[11] = _createElementVNode("span", { class: "icon-benachrichtigungen" }, null, -1)),
              (_unref(globalStore).getNewNotificationCount > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_unref(globalStore).getNewNotificationCount), 1))
                : _createCommentVNode("", true)
            ]),
            (_unref(openSidebar))
              ? (_openBlock(), _createElementBlock("a", _hoisted_15, _toDisplayString(_ctx.$t("sidebar.Notifications")), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 2)), [
        [_directive_permission, 'Notification.Navigation.Show']
      ]),
      _withDirectives((_openBlock(), _createElementBlock("li", {
        class: _normalizeClass({'active': subIsActive('/settings')})
      }, [
        _createVNode(_component_router_link, {
          class: "flex",
          to: "/settings"
        }, {
          default: _withCtx(() => [
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "sidebarIcon" }, [
              _createElementVNode("span", { class: "icon-einstellungen" })
            ], -1)),
            (_unref(openSidebar))
              ? (_openBlock(), _createElementBlock("a", _hoisted_16, _toDisplayString(_ctx.$t("sidebar.Settings")), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1,
          __: [12]
        })
      ], 2)), [
        [_directive_permission, 'Setting.Navigation.Show']
      ]),
      _createElementVNode("li", _hoisted_17, [
        _createVNode(_component_router_link, {
          class: "flex",
          to: "/account"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Avatar)),
            (_unref(openSidebar))
              ? (_openBlock(), _createElementBlock("a", _hoisted_18, [
                  (_unref(globalStore).user?.firstName !== '')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_unref(globalStore).user?.firstName), 1))
                    : _createCommentVNode("", true),
                  _cache[13] || (_cache[13] = _createTextVNode(" ")),
                  (_unref(globalStore).user?.lastName !== '')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_unref(globalStore).user?.lastName), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ])
  ], 2))
}
}

})